<template>
  <div class="checkboxContainer">
    <div class="uiRadio" :class="{'checked':trueVal}"></div>
  </div>
  <!-- <div class="radioBullet">
		<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
		viewBox="0 0 11.2 11.3" style="enable-background:new 0 0 11.2 11.3;" xml:space="preserve" transform="rotate(-90 0 0)" class="box" :class="{'boxOn': trueVal === true}">
		<polyline points="22.7,6 17.9,11.6 15.9,9.9 "/>
		<path class="st1" d="M25.3-8.2c0.1,0.4,0.2,0.8,0.2,1.3c0,2.1-1.7,3.8-3.8,3.8S18-4.8,18-6.9s1.7-3.8,3.8-3.8c0.8,0,1.6,0.3,2.2,0.7
		l0.7-0.8c-0.8-0.6-1.8-1-2.9-1C19.1-11.7,17-9.6,17-6.9s2.2,4.8,4.8,4.8s4.8-2.2,4.8-4.8c0-0.8-0.2-1.5-0.5-2.2L25.3-8.2z"/>
		<path class="boxLine" :class="{'boxLineOne': trueVal === true}" d="M9.4,9.7H2.1c-0.2,0-0.3-0.2-0.3-0.3V2.1c0-0.2,0.2-0.3,0.3-0.3h7.3c0.2,0,0.3,0.2,0.3,0.3v7.3
		C9.7,9.6,9.6,9.7,9.4,9.7z"/>
	</svg>

</svg>
<svg version="1.1" class="check" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 11.2 11.3" style="enable-background:new 0 0 11.2 11.3;" xml:space="preserve" 
:class="{'animateCheck': trueVal === true}">
<polyline class="st0" points="10.5,1.1 5.8,6.7 3.8,5 "/>
</svg>
  </div>-->
</template>

<script>
export default {
  name: "Checkbox",
  props: ["trueVal"],
  data() {
    return {};
  }
};
</script>

<style scoped lang="less">
@import "../../assets/css/style.less";
.checkboxContainer {
  margin: 0;
  display: flex;
  padding-right: 29px;
  margin-bottom: 10px;
  float: right;
}
.uiRadio {
  border: 1px solid @grey-dark;
  min-width: 15px;
  height: 15px;
  position: relative;
  right: 0;
  background: @white;
  box-shadow: inset 0px 0px 1px 5px @white;
  transition: all 0.2s ease-in;
}
.checked {
  border-color: @grey-dark;
  background: @grey-dark;
  box-shadow: inset 0 0 0px 2px @white;
}

// .radioBullet {
//   position: relative;
//   margin-right: -20px;
//   margin-top: 4px;
//   display: inline-block;
//   float: right;
//   svg {
//     position: absolute;
//     width: 16px;
//   }
//   img {
//     position: absolute;
//     width: 16px;
//   }
// }

// .check {
//   transition: all 0.3s;
//   stroke-dasharray: 1000;
//   stroke-dashoffset: -10;
// }

// .animateCheck {
//   stroke-dashoffset: 0;
// }

// .check {
//   fill: #336699;
// }

// .st0 {
//   fill: none;
//   stroke: #336699;
//   stroke-miterlimit: 10;
// }
// .boxLine {
//   fill: none;
//   stroke: #666;
//   stroke-miterlimit: 10;
// }
// .boxLineOne {
//   stroke: #336699;
// }

// .box {
//   stroke: #666;
//   stroke-dasharray: 35;
//   stroke-dashoffset: 0;
// }

// .circleOnFull {
//   stroke-dashoffset: -5;
//   circle {
//     stroke: #336699 !important;
//   }
// }
// .boxOn {
//   fill: transparent;
//   transition: all 0.3s;
//   stroke-dasharray: 25;
//   stroke-dashoffset: -3;
//   z-index: 1;
// }
</style>



// WEBPACK FOOTER //
// src/components/ui/checkbox.vue